import { Comment } from "../leads/comments/types";
import { useVehicleCard } from "@/hooks/useVehicleCard";
import { CommentsSection } from "../components/CommentsSection";

interface VehicleCardCommentsProps {
  comments?: Comment[];
  vehicleCardId: string;
}

export const VehicleCardComments = ({
  comments = [],
  vehicleCardId,
}: VehicleCardCommentsProps) => {
  const { addCommentAsync, isAddingComment, updateCommentAsync, deleteCommentAsync } = useVehicleCard();

  const handleSubmitComment = async (
    text: string,
    isPublic: boolean,
    mentions: string[]
  ) => {
    await addCommentAsync({
      vehicleCardId,
      comment: {
        text,
        author: "Current User", // TODO: Get from auth context
        mentions,
      },
    });
  };

  return (
    <CommentsSection
      comments={comments}
      onSubmitComment={handleSubmitComment}
      onUpdateComment={(commentId, newText) =>
        updateCommentAsync({ vehicleCardId, commentId, text: newText })
      }
      onDeleteComment={(commentId) =>
        deleteCommentAsync({ vehicleCardId, commentId })
      }
      isSubmitting={isAddingComment}
      category="vehicleCard"
    />
  );
};
